import { Component, inject, Inject } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { InputConfirmationModalDataInterface } from './input-confirmation-modal-data.interface';

import '@diekeure/dcr-components/dcr-filled-button.js';
import '@diekeure/dcr-components/dcr-inline-button.js';
import '@diekeure/dcr-components/dcr-outline-button.js';
import '@diekeure/dcr-components/dcr-text-field.js';
import '@diekeure/dcr-components/dcr-tonal-button.js';

@Component({
  standalone: false,
  selector: 'campus-input-confirmation-modal',
  templateUrl: './input-confirmation-modal.component.html',
})
export class InputConfirmationModalComponent implements InputConfirmationModalDataInterface {
  public title: string;
  public message: string;
  public inputLabel: string;
  public inputInitialValue: string;
  public placeholder: string;
  public disableConfirm: boolean;
  public confirmLabel: string;
  public cancelLabel: string;
  public confirmType: 'default' | 'danger' | 'primary';
  public cancelType: 'default' | 'inline' | 'hidden';
  public confirmIcon: string;
  public messageClass: string;
  public pattern?: string;

  public formBuilder = inject(FormBuilder);
  public inputControl: FormControl<string>;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: InputConfirmationModalDataInterface,
    public dialogRef: MatDialogRef<InputConfirmationModalComponent>
  ) {
    this.title = data.title;
    this.message = data.message;
    this.inputLabel = data.inputLabel || 'Naam';
    this.inputInitialValue = data.inputInitialValue;
    this.placeholder = data.placeholder;
    this.disableConfirm = data.disableConfirm;
    this.confirmLabel = data.confirmLabel || 'Ja';
    this.cancelLabel = data.cancelLabel || 'Nee';
    this.confirmType = data.confirmType || 'primary';
    this.cancelType = data.cancelType || 'inline';
    this.confirmIcon = data.confirmIcon;
    this.messageClass = data.messageClass || '[ label-large on-surface text-opacity-medium ]';
    this.inputControl = new FormControl(this.inputInitialValue, Validators.required);
    this.pattern = data.pattern;
  }

  public cancel() {
    this.dialogRef.close(false);
  }

  public confirm() {
    if (this.disableConfirm) return; // workaround because stop propagation does not work
    if (this.inputControl.invalid) return;
    this.dialogRef.close(this.inputControl.value);
  }
}
